import { languages } from "../supportedLanguages";

export const getSupportedLanguages = () => {
	return Object.keys(languages).map(k => ({
		key:k,
		label:(languages as any)[k].label,
	}));
};